import { useState, useEffect } from "react";
/* REACT PACKAGE IMPORTS */
import { Form } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { postAnswer } from "../../../Features/Sessions/Actions/SessionsActions";

import { decode } from "html-entities";
import { addLineBreak } from "../../../Utilities/format";
export default function MultipleChoice({
  position,
  question,
  answer,
  sessionId,
}) {
  const [localAnswer, setLocalAnswer] = useState(answer);
  const dispatch = useDispatch();
  const questionText = decode(question?.question);
  const formattedQuestionText = addLineBreak(questionText);
  const [isCheckboxDisabled, setIsCheckboxDisabled] = useState(false);

  useEffect(() => {
    console.log(localAnswer[0], "this is the local answer for:", question.qid);
  }, [isCheckboxDisabled]);

  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  async function handleOnChange(e) {
    // Create a delay to stop candidates from overloading
    setIsCheckboxDisabled(true);

    const value = parseInt(e.target.value);
    const isChecked = e.target.checked;
    if (!question.qid) return;

    // Get current selected options from the answer or initialize empty array
    const currentSelected =
      localAnswer[0]?.answercontent?.multichoice?.length > 0
        ? [...localAnswer[0].answercontent.multichoice]
        : [];

    // console.log(
    //   currentSelected,
    //   "these are the currently selected answers for question:",
    //   question.qid,
    // );

    // console.log(isChecked, "this tracks if the option is checked or not");

    // Update the array based on whether the option is being checked or unchecked
    let newSelectedOptions;
    console.log(value, isChecked);

    // Remove the value if it exists in the array
    if (!isChecked)
      newSelectedOptions = currentSelected.filter((option) => option !== value);
    if (isChecked && currentSelected.includes(value))
      newSelectedOptions = currentSelected;
    if (isChecked && !currentSelected.includes(value))
      newSelectedOptions = [...currentSelected, value];
    // Add the new value if it's not already in the array

    console.log(
      newSelectedOptions,
      "these are the selected options for question:",
      question.qid,
    );

    const newCurrentAnswer = {
      qid: question.qid,
      answer: { multichoice: newSelectedOptions },
      qhid: question.qhid,
    };

    const newAnswer = [
      {
        qid: question.qid,
        answercontent: { multichoice: newSelectedOptions },
        qhid: question.qhid,
      },
    ];

    dispatch(postAnswer({ esId: sessionId, answer: newCurrentAnswer })).then(
      (response) => {
        setLocalAnswer(newAnswer);
      },
    );
    await sleep(2000);
    setIsCheckboxDisabled(false);
  }

  return (
    <div>
      <p className="fs-4 mb-4">
        <span className="fw-bold">Question {position + 1}</span>:{" "}
        {formattedQuestionText}
      </p>
      <p className="fs-6 fst-italic m-1 text-muted">Select one or more:</p>
      {
        <ol className={"list-group d-flex flex-row flex-wrap row px-3"}>
          {question.options &&
            question.options.map((option, i) => {
              let defaultChecked =
                localAnswer.length > 0
                  ? localAnswer[0]?.answercontent?.multichoice?.includes(
                      option.qoid,
                    )
                  : false;
              const optionText = decode(option.opttext);
              return (
                <li key={i} className={"list-group-item flex gap-2"}>
                  {isCheckboxDisabled ? (
                    <Form.Check
                      type={"checkbox"}
                      label={option.opttext ? optionText : ""}
                      aria-label={option.opttext || "Checkbox"}
                      name={`multipleAnswer_${question.qid}`}
                      value={option.qoid}
                      defaultChecked={defaultChecked}
                      disabled={true}
                      onChange={(e) => handleOnChange(e)}
                    />
                  ) : (
                    <Form.Check
                      type={"checkbox"}
                      label={option.opttext ? optionText : ""}
                      aria-label={option.opttext || "Checkbox"}
                      name={`multipleAnswer_${question.qid}`}
                      value={option.qoid}
                      defaultChecked={defaultChecked}
                      onChange={(e) => handleOnChange(e)}
                    />
                  )}
                </li>
              );
            })}
        </ol>
      }
    </div>
  );
}
